import { useSelector } from 'react-redux';
import Global from '../../../../store/global-selectors';

export const useInventoryShipFroms = () => {
  const shipFroms = useSelector(Global.selectSellerShipFroms);

  return shipFroms.filter((shipFrom) => shipFrom.isAssociatedToInventorySource);
};

export const useNumberOfShipFroms = () => {
  const numberOfShipFroms = useInventoryShipFroms().length;
  return numberOfShipFroms;
};
